import * as Yup from 'yup';
import { translate } from 'helpers/intl';
import messages from 'containers/PasswordRecoveryPages/QuestionScrtMethodForgot/messages';

export default (props: any) =>
  Yup.object().shape({
    questionSecret: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
    response: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
  });
